export const environment = {
    enableLogging: false,
    apiUrl: 'https://pp-umservice.moglix.com',
    auctionServiceUrl: 'https://pp-auctionservice.moglix.com',
    auctionCentralService: 'https://pp-auctioncentralservice.moglix.com',
    biddingServiceUrl: 'https://pp-auctionbidservice.moglix.com',
    auctionApiUrl: 'https://pp-auctionapi.moglix.com',
    debug: true,
    CLIENT_ID: '3ef4738f-6836-47c9-b6fb-a484743af119',
    TENANT_ID: '64652978-5be2-489f-b626-f5f298a3e2e6',
    redirectUri: 'https://pp-e-auction.moglix.com/login',
    auctionRunnerSocketUrl : 'wss://pp-auctionrunner.moglix.com',
    reportsUrl: 'https://pp-auctionreport.moglix.com',
    auctionRunnerUrl : 'https://pp-auctionrunner.moglix.com',   
    globalInternalUrl: 'https://global-internal.zoglix.com',
    imagesUrl: 'https://img.moglimg.com/',
};